<script setup lang="ts">
import { ref, onMounted } from "vue";
import { TimeFrame } from "~/api";
import { Edit } from "@element-plus/icons-vue";
import { VueDraggableNext } from "vue-draggable-next";
import { formatDate } from "~/utils/dateUtils";

const props = defineProps<{
  timeFrameList: TimeFrame[];
}>();

const emit = defineEmits<{
  (e: "editingTimeFrame", value: TimeFrame): void;
}>();

const localTimeFrameList = ref<TimeFrame[]>([]);

onMounted(() => {
  localTimeFrameList.value = props.timeFrameList;
});

const notes = (row: TimeFrame) => {
  const start = row.startDate ? new Date(row.startDate as any) : null;
  const end = row.endDate ? new Date(row.endDate as any) : null;
  if (!start?.getTime() || !end?.getTime()) {
    return "";
  }
  if (start > end) {
    return `Start date is after end date`;
  }
  return "";
};

const dateFormatInCell = (
  _row: any,
  _column: any,
  cellvalue: any,
  _index: number,
) => {
  return cellvalue ? formatDate(cellvalue, 1) : "-";
};
</script>

<template>
  <div v-if="localTimeFrameList" class="sorting-time-frames">
    <VueDraggableNext class="dragArea" :list="localTimeFrameList">
      <div
        v-for="(timeFrame, index) in localTimeFrameList"
        :key="timeFrame.code || timeFrame.label || index"
        class="drag-item"
      >
        <i :class="`mdi mdi-drag-vertical`"></i>
      </div>
    </VueDraggableNext>
    <el-table :data="localTimeFrameList" style="width: 100%">
      <el-table-column label=" Display Label" prop="label" width="150">
        <template #default="{ row }">
          <span>{{ row.label }} </span>
        </template>
      </el-table-column>
      <el-table-column label="Code" prop="code" width="100">
        <template #default="{ row }">
          <span>{{ row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Start"
        prop="startDate"
        width="260"
        :formatter="dateFormatInCell"
      ></el-table-column>
      <el-table-column
        label="End"
        prop="endDate"
        width="260"
        :formatter="dateFormatInCell"
      ></el-table-column>

      <el-table-column label="Edit">
        <template #default="{ row }">
          <div class="actions-column">
            <el-button
              :icon="Edit"
              size="small"
              circle
              @click="emit('editingTimeFrame', row)"
            />
            <div class="notes">{{ notes(row) }}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="less">
.sorting-time-frames {
  display: flex;
  .dragArea {
    margin-top: 1.8em;
    cursor: grab;
    .drag-item {
      margin-top: 1.5em;
    }
  }

  .endpoint-checkbox {
    display: block;
    margin-left: 50px;
  }

  .actions {
    margin-left: 8px;
    .arrow-button {
      margin: 0 2px;
      padding: 2px 6px;
      font-size: 12px;
    }
  }
  .notes {
    display: inline-block;
    margin-left: 8px;
    color: var(--el-color-danger);
  }
}
</style>
